import React, { FC, useState, useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import ProfileMenu from 'screens/Products/Plural/ProfileMenu';
import SupportModal from './SupportModal';
import SwitchAccountModal from './SwitchAccount';
import Popper from 'components/Popper';
import TestEnvLabel from '../TestEnvLabel';
import {
  clearMerchantInfoAction,
  getTRMRedirectUrlAction,
  clearTRMRedirectUrlStateAction,
} from '../../redux/actions/login';
import imgURL from 'lib/imgURL';
import { getProfileImgText, getSelectedProduct } from 'lib/helper';
import notify from '../../lib/notifiy';
import ChangePassword from './ChangePassword';
import { redirectToUrl } from '../../lib/helper';
import useRedirect from '../../hooks/useRedirect';
import { PRODUCTS, UiRoutes, ExternalUrls } from '../../lib/constants';
import {
  clevertapEventConfigList,
  isCitiTheme,
  pushClevertapEvent,
} from '../../lib/analyticsUtil';
import Props from './typing';
import './style.scss';
import Button from 'components/Button';
import UserManagement from 'screens/Home/UserManagement';
import {
  clearChangePasswordAction,
  fetchMerchantAction,
  getPartnerMerchantDetailForDashboard,
} from 'redux/actions/login';
import { SETTINGS_TABS_LINKS } from 'screens/Products/Edge/Settings/constant';
import { useLocation } from 'react-router-dom';
import { getBetaToggleAction } from 'redux/actions/overview';

const Navbar: FC<Props> = (props): JSX.Element => {
  const { push, generatePath } = useRedirect();
  const location = useLocation();
  const isUserVerificationFlow = location.pathname.includes('/user-verification');

  const [isProfileMenu, setIsProfileMenu] = useState<boolean>(false);
  const [isChangePasswordModal, setIsChangePassword] = useState<boolean>(false);
  const [isUserManagementModal, setIsUserManagementModal] =
    useState<boolean>(false);

  const [supportModalVisible, setSupportModalVisible] =
    useState<boolean>(false);
  const [showSwitchAccount, setShowSwitchAcount] = useState<boolean>(false);
  const isProfileSubmitPage = location.pathname === '/user-verification/profile-submitted'; 
  const [previousParentToChild, setPreviousParentToChild] = useState(props.parentToChild);

  const selectedMerchant = useSelector(
    (state: any) => state?.loginReducer?.loginState?.selectedMerchant
  );

  const isCiti = isCitiTheme();

  const handleClickChangePassword = () => {
    setIsChangePassword(true);
    setIsProfileMenu(false);
  };

  const handleCancelChangePasswordClick = () => {
    setIsChangePassword(false);
    props.clearChangePasswordAction();
  };

  const handleClickUserManagement = () => {
    setIsUserManagementModal(true);
    setIsProfileMenu(false);
  };

  const handleCancelUserManagementClick = () => {
    setIsUserManagementModal(false);
  };

  useEffect(() => {
    const { isSuccess, trmRedirectUrl, isFailure, responseMessage } =
      props.trmRedirectUrlState;
    if (isSuccess && trmRedirectUrl) {
      redirectToUrl(trmRedirectUrl);
      props.clearTRMRedirectUrlStateAction();
    } else if (isFailure) {
      notify({
        type: 'error',
        message: responseMessage,
        description: '',
      });
      props.clearTRMRedirectUrlStateAction();
    }
  }, [props.trmRedirectUrlState]);

  useEffect(() => {
    if (
      props.subMerchants &&
      props.subMerchants.length > 0 &&
      !selectedMerchant
    ) {
      // const parentMerchant = props.subMerchants[0];
      // setSelectedMerchantVisible(parentMerchant?.merchantName);
    }
  }, [props.subMerchants]);

  const showSupportModal = () => {
    return (
      <SupportModal
        handleClose={() => setSupportModalVisible(false)}
        merchantId={props?.loginState?.selectedProduct?.mid}
      />
    );
  };

  const showSwitchAccountModal = () => {
    return (
      <SwitchAccountModal
        handleClose={() => setShowSwitchAcount(false)}
        merchantId={props?.loginState?.MerchantId}
      />
    );
  };

  useEffect(() => {}, [props?.loginState?.MerchantId]);

  const checkIfPartnerMerchant = () =>
    props.loginState.partnerId && Boolean(
      props.isPartnerMerchant &&
        props.loginState.MerchantId &&
        props.loginState.MerchantId !== props.loginState.partnerId
    );

  useEffect(() => {
    if (props?.loginState?.selectedMerchant) {
      // setSelectedMerchantVisible(
      //   props?.loginState?.selectedMerchant.merchantName
      // );
    }
  }, [props?.loginState?.selectedMerchant]);

  const handleBackToAllMerchants = () => {
    if (checkIfPartnerMerchant() ) {
      props.getPartnerMerchantDetailForDashboard({
        merchantId: props.loginState?.partnerEdgeMerchantId,
        partnerId: props.loginState?.partnerId,
        citi: false,
      });
    } else if (props?.parentToChild) {
      props.getPartnerMerchantDetailForDashboard({
        merchantId: props.loginState?.parentMerchantId,
        partnerId: props.loginState?.partnerId,
        citi: false,
      });
    }
     else {
      props.clearMerchantInfoAction({});
    }
  };

    useEffect(() => {
    if (props.emailForBeta && props?.isSelfServe) {
      props.getBetaToggleAction(props.emailForBeta);
    }
  }, [props.emailForBeta, props.isSelfServe]);

    useEffect(() => {
    if (previousParentToChild === true && props.parentToChild === false && props.loginState.isParentMerchant) {
      push(UiRoutes.ALL_MERCHANTS);
    }
    setPreviousParentToChild(props.parentToChild);
  }, [props.parentToChild, props.loginState.isParentMerchant]);

  const isBPCLChildMerchant = useMemo(() => {
  const parentDetails = props?.stepperDetails?.parent_details;
  return parentDetails?.mid && parentDetails?.name?.toUpperCase() === 'BPCL';
}, [props?.stepperDetails?.parent_details]);

  const showBetaUI = props.betaToggle?.isSuccess && props?.betaToggleState;
  const showVerificationSubnav =
  isUserVerificationFlow && !isProfileSubmitPage ;

  return (
    <React.Fragment>
      {(checkIfPartnerMerchant() || props.parentToChild) ? (
        <nav
          className={`navbar justify-content-flex-end${
            props.isCollapsed ? 'navbar-collapsed' : ''
          }`}
          id='plural-xt-sticky-header'
        >
          <div className='navbar-subsection'>
          <div className={`top-right top-right-max-width`}>
            <ul>
              <span className='cursor-pointer all-merchant-button-wrapper'>
                <img
                  src={isCiti ? imgURL['citi-back'] : imgURL['back-arrow-blue']}
                  className='back-arrow-blue'
                />
                <button
                  onClick={() => handleBackToAllMerchants()}
                  className='header-blue-button'
                >
                  All Merchants
                </button>
              </span>
              <div className='divider'></div>
              <li>
                <div
                  title={`${props.loginState.merchantName?.split(' ')[0]} ( ${
                    props.loginState.MerchantId
                  } )`}
                  className='merchant-name'
                >
                  {props.loginState.merchantName?.split(' ')[0]} ({' '}
                  {props.loginState.MerchantId} )
                </div>
              </li>
              <div className='divider'></div>
              <li className='dropdown'>
                <Popper
                  visible={isProfileMenu}
                  placement='bottomRight'
                  parentId='plural-xt-sticky-header'
                  onVisibleChange={() => {
                    setIsProfileMenu(!isProfileMenu);
                  }}
                  content={
                    <ProfileMenu
                      handleClickChangePassword={handleClickChangePassword}
                      handleClickUserManagement={handleClickUserManagement}
                      clearMerchantInfoAction={() =>
                        props.clearMerchantInfoAction({})
                      }
                    />
                  }
                  className='popper-navbar'
                >
                  <div className='user-profile'>
                    {props?.loginState?.UserFullName
                      ? getProfileImgText(props.loginState.UserFullName)
                      : 'N/A'}
                  </div>
                </Popper>
              </li>
            </ul>
          </div>
          </div>
          {!props.isKycNavBar &&
            !props.isAdmin &&
            props.loginState.isSelfServe &&
            props.isSelfServe && <TestEnvLabel />}
        </nav>
      ): showVerificationSubnav ? (
      <nav
        className={`navbar ${props.isCollapsed ? 'navbar-collapsed' : ''}`}
        id='plural-xt-sticky-header'
      >
        <div className='navbar-save-and-goto'>
          <div className='top-left-save-and-goto'>
            <Button
              label={
                <span style={{ gap: '4px', display: 'flex', alignItems: 'center' }}>
                  <img src={imgURL['save&go']} alt='arrow-left' />
                  Save &amp; go to dashboard
                </span>
              }
              btnStyleClass='save-and-go-to-dashboard'
              onClick={() => {
                push(UiRoutes.OVERVIEW);
              }}
              enable
            />
          </div>
          <div
            className= "top-right"
          >
            <ul>
                <>
                  <>
                    <li>
                      <span
                        onClick={() => setSupportModalVisible(true)}
                        style={{ cursor: 'pointer' }}
                        className='overflow-ellipse'
                        title={'Contact Support'}
                      >
                        <img src={imgURL.phone} alt='phone' />
                        Contact Support
                      </span>
                    </li>
                    <div className='divider'></div>
                  </>

                  {!props.isKycNavBar && (
                    <>
                      <li>
                        <span
                          onClick={() => {
                            const path = ExternalUrls.DOCUMENTATION_URL;
                            pushClevertapEvent(
                              clevertapEventConfigList.DOCUMENTATION_CLICKED
                            );
                            window.open(path);
                          }}
                          style={{ cursor: 'pointer' }}
                          className='overflow-ellipse'
                          title={'Documentation'}
                        >
                          <img src={imgURL['help-icon']} alt='help' />
                          Documentation
                        </span>
                      </li>
                      <div className='divider'></div>
                    </>
                  )}
                </>
            

              <li className='dropdown'>
                <Popper
                  visible={isProfileMenu}
                  placement='bottomRight'
                  parentId='plural-xt-sticky-header'
                  onVisibleChange={() => {
                    setIsProfileMenu(!isProfileMenu);
                  }}
                  content={
                    <ProfileMenu
                      handleClickChangePassword={handleClickChangePassword}
                      handleClickUserManagement={handleClickUserManagement}
                      clearMerchantInfoAction={() =>
                        props.clearMerchantInfoAction({})
                      }
                    />
                  }
                  className='popper-navbar'
                >
                  <div className='user-profile'>
                    {props?.loginState?.UserFullName
                      ? getProfileImgText(props.loginState.UserFullName)
                      : 'N/A'}
                  </div>
                </Popper>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    ) : (
        <nav
          className={`navbar ${props.isCollapsed ? 'navbar-collapsed' : ''}
            ${isProfileSubmitPage ? 'no-sidebar-navbar' : ''} 
            ${
              process.env.REACT_APP_BUILD_ENV !== 'qa' &&
              process.env.REACT_APP_BUILD_ENV !== 'stag' &&
              !props.isKycNavBar
                ? 'justify-content-flex-end'
                : ''
            }
          `}
          id='plural-xt-sticky-header'
        >
          <div className='navbar-subsection'>
            {!props.isKycNavBar &&
              (process.env.REACT_APP_BUILD_ENV === 'qa' ||
                process.env.REACT_APP_BUILD_ENV === 'stag') && <div />}

            {props.isKycNavBar && !props.isKycSubmitted && (
              <div className={`top-left`}>
                <Button
                  btnStyleClass='back-dashboard'
                  label='Back to dashboard'
                  btnIcon={
                    <img className='back-icon' src={imgURL['arrowLeft']} />
                  }
                  btnIconPosition='left'
                  onClick={() => {
                    push(UiRoutes.OVERVIEW);
                  }}
                  enable
                />
              </div>
            )}
            <div className='divider'></div>
            {props.isKycNavBar && props.isKycSubmitted && (
              <div className={`top-left`}>
                <div className='logo'>
                  <a href='#'>
                    <img
                      className='plural-logo'
                      src={imgURL.logo}
                      alt='Plural'
                      onClick={(e) => {
                        e.preventDefault();
                        push(generatePath(UiRoutes.OVERVIEW));
                      }}
                    />
                  </a>
                </div>
              </div>
            )}

            <div
              className={`top-right ${props.isKycSubmitted && 'kycSubmitted'} ${
                process.env.REACT_APP_BUILD_ENV === 'qa' ||
                process.env.REACT_APP_BUILD_ENV === 'dev' ||
                process.env.REACT_APP_BUILD_ENV === 'stag'
                  ? 'top-right-max-width'
                  : ''
              }`}
            >
              <ul>
                {Boolean(props.isAdmin && props.loginState.MerchantId) && (
                  <>
                    <span className='cursor-pointer all-merchant-button-wrapper'>
                      <img
                        src={imgURL['back-arrow-blue']}
                        className='back-arrow-blue'
                      />
                      <button
                        onClick={() => handleBackToAllMerchants()}
                        className='header-blue-button'
                      >
                        All Merchants
                      </button>
                    </span>
                    <div className='divider'></div>
                    <button
                    onClick={() => {
                      const selectedProduct = getSelectedProduct();
                      const path =
                        selectedProduct === PRODUCTS?.EDGE ||
                        selectedProduct === PRODUCTS?.PAYOUT
                          ? UiRoutes.EDGE_SETTINGS
                          : UiRoutes.SETTINGS;
                      push(path, {
                        tab: SETTINGS_TABS_LINKS.customization.value,
                      });
                    }}
                    className='header-blue-button'
                  >
                    Customizations
                  </button>
                    <div className='divider'></div>
                    <li>
                      <div
                        title={`${
                          props.loginState.merchantName?.split(' ')[0]
                        } ( ${props.loginState.MerchantId} )`}
                        className='merchant-name'
                      >
                        {props.loginState.merchantName?.split(' ')[0]} ({' '}
                        {props.loginState.MerchantId} )
                      </div>
                    </li>
                    <div className='divider'></div>
                  </>
                )}
                {props.showTrmPortalLink && (
                  <>
                    <li>
                      <span
                        onClick={() => {
                          props.getTRMRedirectUrlAction();
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={imgURL['trm-icon']} alt='trm' />
                        TRM
                      </span>
                    </li>
                    <div className='divider'></div>
                  </>
                )}
                {!props.isAdmin && (
                  <>
                    {props.virtualStoreId ? (
                      <>
                        <li>
                          <span
                            onClick={() => {
                              push(UiRoutes.SUPPORTREQUESTS);
                            }}
                            style={{ cursor: 'pointer' }}
                            className='overflow-ellipse'
                            title={'Support Requests'}
                          >
                            <img
                              className='support-request'
                              src={imgURL['support-request']}
                              alt='Support Request'
                            />
                            Support Requests
                          </span>
                        </li>
                        <div className='divider'></div>
                      </>
                    ) : (
                      <></>
                    )}

                    {props.MerchantList?.length > 1 && (
                      <>
                        <li>
                          <span
                            onClick={() => setShowSwitchAcount(true)}
                            style={{ cursor: 'pointer' }}
                            className='overflow-ellipse'
                            title={'Switch Account'}
                          >
                            <img src={imgURL['account-circle']} alt='phone' />
                            Switch Account
                          </span>
                        </li>
                        <div className='divider'></div>
                      </>
                    )}
                    {
                      <>
                        <li>
                          <span
                            onClick={() => setSupportModalVisible(true)}
                            style={{ cursor: 'pointer' }}
                            className='overflow-ellipse'
                            title={'Contact Support'}
                          >
                            <img src={imgURL.phone} alt='phone' />
                            Contact Support
                          </span>
                        </li>
                        <div className='divider'></div>
                      </>
                    }

                    {!props.isKycNavBar && (
                      <>
                        <li>
                          <span
                            onClick={() => {
                              const path = ExternalUrls.DOCUMENTATION_URL;
                              pushClevertapEvent(
                                clevertapEventConfigList.DOCUMENTATION_CLICKED
                              );
                              window.open(path);
                            }}
                            style={{ cursor: 'pointer' }}
                            className='overflow-ellipse'
                            title={'Documentation'}
                          >
                            <img src={imgURL['help-icon']} alt='help' />
                            Documentation
                          </span>
                        </li>
                        <div className='divider'></div>
                      </>
                    )}
                  </>
                )}

                <li className='dropdown'>
                  <Popper
                    visible={isProfileMenu}
                    placement='bottomRight'
                    parentId='plural-xt-sticky-header'
                    onVisibleChange={() => {
                      setIsProfileMenu(!isProfileMenu);
                    }}
                    content={
                      <ProfileMenu
                        handleClickChangePassword={handleClickChangePassword}
                        handleClickUserManagement={handleClickUserManagement}
                        clearMerchantInfoAction={() =>
                          props.clearMerchantInfoAction({})
                        }
                      />
                    }
                    className='popper-navbar'
                  >
                    <div className='user-profile'>
                      {props?.loginState?.UserFullName
                        ? getProfileImgText(props.loginState.UserFullName)
                        : 'N/A'}
                    </div>
                  </Popper>
                </li>
              </ul>
            </div>
          </div>
           {!isUserVerificationFlow &&
            !isBPCLChildMerchant &&
            !props.isAdmin &&
            showBetaUI &&
            props?.loginState?.isTransactingMerchant && <TestEnvLabel />}
        </nav>
      )}

      {supportModalVisible && showSupportModal()}
      {showSwitchAccount && showSwitchAccountModal()}
      {isChangePasswordModal && (
        <ChangePassword cancelHandler={handleCancelChangePasswordClick} />
      )}
      {isUserManagementModal && (
        <UserManagement cancelHandler={handleCancelUserManagementClick} />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({
  sidebarReducer,
  loginReducer,
  validationReducer,
  overviewReducer,
  onboardingReducer
}) => ({
  isCollapsed: sidebarReducer.isCollapsed,
  loginState: loginReducer.loginState,
  isAdmin: loginReducer.loginState.isAdmin,
  isPartnerMerchant: loginReducer.loginState.isPartnerMerchant,
  MerchantList: loginReducer.loginState.MerchantList,
  validationErrorState: validationReducer.validationErrorState.validationErrors,
  showTrmPortalLink: loginReducer.loginState.showTrmPortalLink || false,
  trmRedirectUrlState: loginReducer.trmRedirectUrlState,
  virtualStoreId: loginReducer.loginState.virtualStoreId || '',
  subMerchants: loginReducer.loginState?.subMerchants,
  isSelfServe: loginReducer.loginState?.isSelfServe,
  emailForBeta: loginReducer?.loginState?.UserEmail || '',
  betaToggleState: overviewReducer?.initialBetaToggleState?.data?.isAvailable,
  betaToggle:  overviewReducer?.initialBetaToggleState,
  parentToChild: loginReducer.loginState?.isParentToChild ? true : false,
  stepperDetails: onboardingReducer.stepperDetails?.data,
});

export default connect(mapStateToProps, {
  clearChangePasswordAction,
  clearMerchantInfoAction,
  getTRMRedirectUrlAction,
  clearTRMRedirectUrlStateAction,
  getPartnerMerchantDetailForDashboard,
  fetchMerchantAction,
  getBetaToggleAction
})(Navbar);
